module.exports = __webpack_public_path__ + "img/img-2.2ca99c5c.png";